import { SET_AADD_BENF_LIST_PAGE, SET_ANM_ID_SELECTED, SET_ARRIVAL_STATUS, SET_BENF_DUE_LIST_PAGE_TYPE, SET_GO_TO_SERVICES, SET_MAIN_PAGE_TOOGLE, SET_REMOVAL_REASON_DATA, SET_SESSION_DETAIL_DATA, SET_SESSION_ID, SET_SHOW_DUE_LIST, SET_SHOW_DUE_LIST_FROM_MAIN_PAGE, SET_SHOW_UPCOMING_SESSION_DETAILS_BY_ID, SET_VHND_EXECUTION_STATUS } from "@store/types/eventExecutionTypes";

export const setShowUpcomingSessionDetailsPageById = (data: any) => {
    return {
        type: SET_SHOW_UPCOMING_SESSION_DETAILS_BY_ID,
        payload: data
    };
};

export const setShowDueList = (data: any) => {
    return {
        type: SET_SHOW_DUE_LIST,
        payload: data
    };
};

export const setShowDueListFromMainPage = (data: any) => {
    return {
        type: SET_SHOW_DUE_LIST_FROM_MAIN_PAGE,
        payload: data
    };
};

export const setVhndExecutionStatus = (data: any) => {
    return {
        type: SET_VHND_EXECUTION_STATUS,
        payload: data
    };
};

export const setArrivalStatus = (data: any) => {
    return {
        type: SET_ARRIVAL_STATUS,
        payload: data
    };
};

export const setRemovalReasonData = (data: any) => {
    return {
        type: SET_REMOVAL_REASON_DATA,
        payload: data
    };
};

export const setSessionDetailData = (data: any) => {
    return {
        type: SET_SESSION_DETAIL_DATA,
        payload: data
    };
};

export const setToogle = (data: any) => {
    return {
        type: SET_MAIN_PAGE_TOOGLE,
        payload: data
    };
};

export const setSessionId = (data: any) => {
    return {
        type: SET_SESSION_ID,
        payload: data
    };
};

export const setListPageType = (data: any) => {
    return {
        type: SET_BENF_DUE_LIST_PAGE_TYPE,
        payload: data
    };
};

export const setAddBenfListPage = (data: any) => {
    return {
        type: SET_AADD_BENF_LIST_PAGE,
        payload: data
    };
};

export const setGoToServices = (data: any) => {
    return {
        type: SET_GO_TO_SERVICES,
        payload: data
    };
};

export const setAnmIdSelectedByMoic = (data: any) => {
    return {
        type: SET_ANM_ID_SELECTED,
        payload: data
    };
};